import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';

const json = {
  1: {
    unit: 'Unit 8',
    id: 'WB3-U8-P59-E1',
    audio: '',
    video: '',
    component: D1,
    checkDuplicated: true,
    exerciseKey: 'img/FriendsPlus/Page59/E1/Key/answerKey.png',
    titleImage: '',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page59/E1/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page59/E1/2.jpg' },
        { url: 'img/FriendsPlus/Page59/E1/3.jpg', input: true, answer: "cold/happy/hungry/hot/sunny" },
        { url: 'img/FriendsPlus/Page59/E1/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page59/E1/5.jpg' },
        { url: 'img/FriendsPlus/Page59/E1/6.jpg', input: true, answer: "go/ride/eat/fly" },
        { url: 'img/FriendsPlus/Page59/E1/7.jpg' },
        { url: 'img/FriendsPlus/Page59/E1/8.jpg', input: true, answer: "cold/happy/hungry/hot/sunny" },
        { url: 'img/FriendsPlus/Page59/E1/9.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page59/E1/10.jpg' },
        { url: 'img/FriendsPlus/Page59/E1/11.jpg', input: true, answer: "go/ride/eat/fly" },
        { url: 'img/FriendsPlus/Page59/E1/12.jpg' },
        { url: 'img/FriendsPlus/Page59/E1/13.jpg', input: true, answer: "cold/happy/hungry/hot/sunny" },
        { url: 'img/FriendsPlus/Page59/E1/14.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page59/E1/15.jpg' },
        { url: 'img/FriendsPlus/Page59/E1/16.jpg', input: true, answer: "go/ride/eat/fly" },
        { url: 'img/FriendsPlus/Page59/E1/17.jpg' },
        { url: 'img/FriendsPlus/Page59/E1/18.jpg', input: true, answer: "cold/happy/hungry/hot/sunny" },
        { url: 'img/FriendsPlus/Page59/E1/19.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page59/E1/20.jpg' },
        { url: 'img/FriendsPlus/Page59/E1/21.jpg', input: true, answer: "go/ride/eat/fly" },
        { url: 'img/FriendsPlus/Page59/E1/22.jpg' },
        { url: 'img/FriendsPlus/Page59/E1/23.jpg', input: true, answer: "cold/happy/hungry/hot/sunny" },
        { url: 'img/FriendsPlus/Page59/E1/24.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page59/E1/25.jpg' },
      ],

    ]
  },
  2: { // Exercise num
    unit: 'Unit 8',
    id: 'WB3-U8-P59-E2',
    audio: '',
    video: '',
    exerciseKey: '',
    component: DesignUnderLine,
    hideBtnFooter: true,
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page59/E2/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page59/E2/2.jpg' },
        { url: 'img/FriendsPlus/Page59/E2/3.jpg', input: 2 },
        { url: 'img/FriendsPlus/Page59/E2/4.jpg', input: 2 },
        { url: 'img/FriendsPlus/Page59/E2/5.jpg' },
        { url: 'img/FriendsPlus/Page59/E2/6.jpg', input: 3 },
        { url: 'img/FriendsPlus/Page59/E2/7.jpg', input: 3 },
        { url: 'img/FriendsPlus/Page59/E2/8.jpg' },
        { url: 'img/FriendsPlus/Page59/E2/9.jpg', input: 4 },
        { url: 'img/FriendsPlus/Page59/E2/10.jpg', input: 4 },
        { url: 'img/FriendsPlus/Page59/E2/11.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page59/E2/12.jpg' },
        { url: 'img/FriendsPlus/Page59/E2/13.jpg', input: 5 },
        { url: 'img/FriendsPlus/Page59/E2/14.jpg', input: 5 },
        { url: 'img/FriendsPlus/Page59/E2/15.jpg' },
        { url: 'img/FriendsPlus/Page59/E2/16.jpg', input: 6 },
        { url: 'img/FriendsPlus/Page59/E2/17.jpg', input: 6 },
        { url: 'img/FriendsPlus/Page59/E2/18.jpg' },
        { url: 'img/FriendsPlus/Page59/E2/19.jpg', input: 7 },
        { url: 'img/FriendsPlus/Page59/E2/20.jpg', input: 7 },
        { url: 'img/FriendsPlus/Page59/E2/21.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page59/E2/22.jpg' },
      ],

    ]
  },
  3: {
    unit: 'Unit 8',
    id: 'WB3-U8-P59-E3',
    audio: '',
    video: '',
    component: D1,
    hideBtnFooter: true,
    exerciseKey: 'img/FriendsPlus/Page59/E1/Key/answerKey.png',
    titleImage: '',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page59/E3/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page59/E3/2.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page59/E3/3.jpg' },
        { url: 'img/FriendsPlus/Page59/E3/4.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page59/E3/5.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page59/E3/6.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page59/E3/7.jpg' },
        { url: 'img/FriendsPlus/Page59/E3/8.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page59/E3/9.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page59/E3/10.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page59/E3/11.jpg' },
        { url: 'img/FriendsPlus/Page59/E3/12.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page59/E3/13.jpg' },
      ],
      [
        // Column8
        { url: 'img/FriendsPlus/Page59/E3/14.jpg' },
      ],
      [
        // Column9
        { url: 'img/FriendsPlus/Page59/E3/15.jpg' },
        { url: 'img/FriendsPlus/Page59/E3/16.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page59/E3/17.jpg' },
      ],
      [
        // Column10
        { url: 'img/FriendsPlus/Page59/E3/18.jpg' },
      ],
      [
        // Column11
        { url: 'img/FriendsPlus/Page59/E3/19.jpg' },
        { url: 'img/FriendsPlus/Page59/E3/20.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page59/E3/21.jpg' },
      ],
      [
        // Column12
        { url: 'img/FriendsPlus/Page59/E3/22.jpg' },
      ],


    ]
  },



}
export default json;